import { Record, fromJS, Map } from 'immutable'

export const SegmentStatus = Object.freeze({
  HIDDEN: 'HIDDEN',
  ENABLED: 'ENABLED',
  ARCHIVED: 'ARCHIVED',
})

export const SegmentType = Object.freeze({
  QUERY: 'QUERY',
  ID_LIST: 'ID_LIST',
})

const Segment = Record({
  id: null,
  authorId: null,
  createdAt: null,
  name: 'Your Segment',
  orgId: null,
  query: Map(),
  status: SegmentStatus.ENABLED,
  type: SegmentType.ID_LIST,
  updatedAt: null,
})

export const parseSegment = ({ query, ...rest }) => {
  return new Segment({
    ...rest,
    query: fromJS(query),
  })
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/segment/models.js